import {Collapse, Divider, message, Modal, Space, Tag} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/UI/Button";
import { getAllowCreateNewDevicePermission, getPermission } from "../../services/permisssion";
import deviceStatus from "../../utils/deviceStatus";
import permissionType from "../../utils/permissionType";
import {
  EditOutlined, EyeOutlined, TagsFilled, TagsOutlined,
} from '@ant-design/icons'
import Head from "../../components/Head";
import ActionArea from "../../components/ActionArea";
import SmartSearch from "../../components/UI/SmartSearch";
import SelectInput from "../../components/UI/SelectInput";
import List from "../../components/List";
import { exportCsvDevices, getDevicesList, pushDeviceCommand } from "../../services/devices";
import devicesCommandList from "../../utils/devicesCommandList";
import Input from "../../components/UI/Input";
import React from "react";
import direction from "../../utils/filterDirectionOrder";
import { notificationError } from "../../services/notification";
import { useLoading } from "../../context/LoadingProvider/useLoading";
import { sendSystemLog, useAuth } from "../../context/AuthProvider/useAuth";
import { useListRecord } from "../../context/ListRecordProvider/useListRecord";
import { IParams } from "../../context/ListRecordProvider/types";
import { DateFormatEnum } from "../../enums/dateFormatEnum";
import { compareDates, stringCompare } from "../../utils/sorters";
import dayjs from "dayjs";
import {IJackpotHistoryItem} from "../JackpotHistory";
import ModalSelector from "../Logs/ModalSelector";
import ModalTagsSelector from "./ModalTagsSelector";
import {getDeviceTags} from "../../services/tags";
import SearchTagsSelector from "./SearchTagsSelector";
const { Panel } = Collapse;

function Devices( props: {accessLevel: string;}) {
  const selectOptions = [
    {name: 'All', value: 'All'},
    {name: 'Available', value: deviceStatus.available},
    {name: 'Inactive', value: deviceStatus.inactive},
    {name: 'Blocked', value: deviceStatus.blocked},
  ]
  const loading = useLoading()
  const history = useNavigate()
  const { canEdit } = useAuth()
  const  affiliation  = useAuth().response?.affiliation
  const listRecord = useListRecord()
  const record = listRecord.getRecord('devicesList')
  const urlParams = new URLSearchParams(window.location.search);
  const useRecord = urlParams.get('useRecord')
  const log = {
    log_type: 'visited',
    log_object: 'devices'
  }
  const [modalVisibleTag, setModalVisibleTag] = useState(false)

  const [search, setSearch] = useState('')
  const [devTags, setDevTags] = useState([])
  const [canCreateDevice, setCanCreateDevice] = useState(false)
  const [params, setParams] = useState<IParams>({
    status: selectOptions[0].value,
    fieldOrder: '',
    directionOrder: '',
    id: null,
    name: '',
    type: '',
    tags:[]
  })
  const [validSearch, setValidSearch] = useState(false)
  const [searchTags, setSearchTags] = useState([])
  const [devicesList, setDevicesList] = useState({
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  })
  const [canSendPushCommand, setCanSendPushCommand] = useState(false)
  const [command, setCommand] = useState(devicesCommandList[0].value)
  const [commandMessage, setCommandMessage] = useState({
    title: '',
    message: '',
  })
  const [modal, setModal] = useState({
    action: false,
    objectType: false
  })
  const [modalSearch, setModalSearch] = useState(false)

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if(!event.repeat && event.key === 'Enter') {
      onRefresh()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  useEffect(() => {
    setParams({...params, tags: searchTags});
  }, [searchTags])

  useEffect(() => {
    (async() => {
      if (!modal.action)
        await onRefresh()
    })
  }, [modal.action])

  useEffect(() => {
    (async() =>{
      loading.addLoading()
      const pushPermission = await getPermission('devices_push_command')
      const createPermission = await getAllowCreateNewDevicePermission()
      setCanCreateDevice(createPermission.return)
      setCanSendPushCommand(pushPermission === permissionType.manage)
      if(record && useRecord) {
        const response = await getDevicesList({
          status: record.status,
          [`${record.type}Id`]: record.type==="serial"?record.name:record.id,
          tags: record.tags?.map((tag: any) => tag.id).join()
        })
        if(response.list.length >= 30000) {
          notificationError('Search returned over 30,000 results. Limiting to first 30,000. Please refine your search')
        }
        setDevicesList(response)
        setParams(record)
        setSearch(record.name)
        if (record.tags)
          setSearchTags(record.tags)
      }
      loading.removeLoading()
    })()
  }, [])

  const closeTagsModal = async() => {
    await onRefresh()
    setModal({...modal, action: false})
  }

  const onRefresh = async () => {
    loading.addLoading()
    let requestParams = {
      status: params.status,
      [`${params.type}Id`]: params.type==="serial"?params.name:params.id,
      fieldOrder: '',
      directionOrder: '',
      tags: searchTags.map((tag: any) => tag.id).join()
    }

    const response = await getDevicesList(requestParams)
    if(response.list.length >= 30000) {
      notificationError('Search returned over 30,000 results. Limiting to first 30,000. Please refine your search')
    }
    setDevicesList(response)
    listRecord.addRecord('devicesList', params)
    loading.removeLoading()
  }

  const exportCsv = async () => {
    loading.addLoading()
    const requestParams = {
      status: params.status,
      [`${params.type}Id`]: params.id
    }
    await exportCsvDevices(requestParams)
    loading.removeLoading()
  }

  const getStatusLabel = (status: string) => {
    if(status === 'AVAILABLE') {
      return <Tag color="green">{status}</Tag>
    }

    return <Tag color="red">{status}</Tag>

  }

  const showTags = async (id: string) => {

    let devList: never[] = [];
    // @ts-ignore
    devList.push({id: id})

    const resDev = await getDeviceTags(devList)
    if (resDev) {
      setDevTags(resDev.tags)
    }
    setModalVisibleTag(true)

  }

  const getActionButtons = (id: string, record: any) => {
    return(
        <div className="cashiers__table__actions">
          <Button
              onClick={() => showTags(id)}
              type='secondary'
              style={{backgroundColor: '#2fa4e7'}}
              disabled={record.countTags==="0"}
          >
            {record.countTags==="0" &&
                <TagsOutlined style={{ fontSize: '16px', color: '#FFF' }} />
            }
            {record.countTags!=="0" &&
                <TagsFilled style={{ fontSize: '16px', color: '#FFF' }} />
            }
          </Button>
          <Button
              onClick={() => history(`../devices/new/${id}`)}
              type='primary'
              style={{backgroundColor: '#2fa4e7'}}
              disabled={!canEdit}
          >
            <EditOutlined style={{ fontSize: '16px', color: '#FFF' }} />
          </Button>
        </div>
    )
  }

  const onPushCommand = async () => {
    if(command === 'client-message' && !commandMessage.title) return notificationError('Title is required')
    if(command === 'client-message' && !commandMessage.message) return notificationError('Message is required')

    let params = {
      command,
      deviceList: devicesList.list.map((device: any) => device.id).join(),
      title: commandMessage.title,
      message: commandMessage.message,
    }

    await pushDeviceCommand(params)
  }

  return (
      <div className="devices">
        <meta name="viewport" content="width=device-width, initial-scale=.75"/>


        <Head
            title="All Devices"
        />
        <ModalTagsSelector
            visible={modal.action}
            deviceList={devicesList.list}
            title="Manage Tags"
            onClose={() => closeTagsModal()}
            isManufacturer={affiliation === 'manufacturer'}
        />
        <SearchTagsSelector
            visible={modalSearch}
            title="Tags for Search"
            tags={searchTags}
            onSelectChange={setSearchTags}
            onClose={() => setModalSearch(false)}
            isManufacturer={affiliation === 'manufacturer'}
        />
        <Modal
            title="Tags"
            open={modalVisibleTag}
            onCancel={() => setModalVisibleTag(false)}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
          <List

              rows={devTags}
              columns={[
                {
                  title: 'Tag',
                  dataIndex: 'name',
                  key: 'name',
                  render: (value: string) => value,
                  sorter: (a: any, b: any) => stringCompare(a.identifier, b.identifier),
                  width: 150,
                },
                {
                  title: 'Date Applied',
                  dataIndex: 'applyTime',
                  key: 'applyTime',
                  render: (value: string) => value,
                  sorter: (a: any, b: any) => stringCompare(a.alias, b.alias),
                  width: 100
                },
                {
                  title: 'Distributor',
                  dataIndex: 'distributorId',
                  key: 'distributorId',
                  render: (value: number) => value?'Yes':'',
                  sorter: (a: any, b: any) => stringCompare(a.alias, b.alias),
                  width: 100
                },
              ]}
          />
        </Modal>
        <div className="action-area-component">
          <div className="action-area-component__top">
            <SmartSearch
                value={search}
                triggerWith={record?.name || ''}
                onChange={(e: string) => setSearch(e)}
                onValidSearch={setValidSearch}
                label='Smart Search'
                status="active,inactive,blocked,available"
                validOnEmpty
                searchBy={['distributor', 'charity', 'location', 'device']}
                onObjValueChange={(e: any) => setParams({...params, ...e})}
                autoFocus
            />
            <SelectInput
                options={selectOptions}
                label='Status'
                onSelectChange={(e: string) => setParams({...params, status: e})}
                value={params.status}
            />
          </div>

          <div className="action-area-component__bottom">
            {searchTags.length === 0 &&
                <Button onClick={() => setModalSearch(true)} type="primary" disabled={!validSearch}>
                  <TagsFilled style={{ fontSize: '16px', color: '#FFF' }} />
                </Button>
            }
            {searchTags.length !== 0 &&
                <Button onClick={() => setModalSearch(true)} type="primary" disabled={!validSearch} style={{ backgroundColor: 'green' }}>
                  <TagsFilled style={{ fontSize: '16px', color: '#FFF' }} />
                </Button>
            }
            <Button onClick={onRefresh} type="primary" disabled={!validSearch}>
              <p>Search</p>
            </Button>
            &nbsp;&nbsp;
            <Button type="primary" onClick={exportCsv} style={{height: 32}} >
              <p>Export CSV</p>
            </Button>
          </div>
        </div>

        <div className="devices__action-container" >
          <Space>
            <div hidden={!canSendPushCommand}>
              <Collapse>
                <Panel header="Command to devices" key={"cmdToDevices"}>
                  <div className="devices__action-area">
                    <SelectInput
                        options={devicesCommandList}
                        label='Command'
                        onSelectChange={(e: string) => setCommand(e)}
                        value={command}
                        disabled={!canSendPushCommand}
                    />
                    {command === 'client-message' && (
                        <>
                          <Input
                              value={commandMessage.title}
                              onChange={(e: any) => setCommandMessage({...commandMessage, title: e.target.value})}
                              label="Title"
                              placeholder="Title"
                          />
                          <Input
                              value={commandMessage.message}
                              onChange={(e: any) => setCommandMessage({...commandMessage, message: e.target.value})}
                              label="Message"
                              placeholder="Message"
                              style={{width: '300px'}}
                          />
                        </>
                    )}
                    <Button type="primary" disabled={!canSendPushCommand || devicesList.list.length === 0}
                            onClick={() => onPushCommand()} style={{height:'32px' ,backgroundColor: 'red'}}>
                      <p>Push command</p>
                    </Button>
                  </div>
                </Panel>
              </Collapse>
            </div>
            <div hidden={!canEdit}>
              <Button
                  onClick={() =>  setModal({...modal, action: true})}
                  type='primary'
                  disabled={devicesList.list.length === 0}
              >
                <TagsOutlined style={{ fontSize: '16px', color: '#FFF' }} />Manage Tags
              </Button>

            </div>
          </Space>
        </div>
        <List

            rows={devicesList.list}
            columns={[
              {
                title: 'Device ID',
                dataIndex: 'identifier',
                key: 'identifier',
                render: (value: string) => value,
                sorter: (a: any, b: any) => stringCompare(a.identifier, b.identifier),
                width: 150,
              },
              {
                title: 'Alias',
                dataIndex: 'alias',
                key: 'alias',
                render: (value: string) => value,
                sorter: (a: any, b: any) => stringCompare(a.alias, b.alias),
                width: 100
              },
              {
                title: 'Serial',
                dataIndex: 'serialNumber',
                key: 'serialNumber',
                render: (value: string) => value,
                sorter: (a: any, b: any) => stringCompare(a.serialNumber!=null?a.serialNumber:"zzz", b.serialNumber!=null?b.serialNumber:"zzz"),
                width: 100
              },
              {
                title: 'Distributor',
                dataIndex: 'distributor',
                key: 'distributor',
                render: (value: string) => value,
                sorter: (a: any, b: any) => stringCompare(a.distributor, b.distributor),
                width: 150
              },
              {
                title: 'Charity',
                dataIndex: 'charity',
                key: 'charity',
                render: (value: string) => value,
                sorter: (a: any, b: any) => stringCompare(a.charity, b.charity),
                width: 150
              },
              {
                title: 'Location',
                dataIndex: 'location',
                key: 'location',
                render: (value: string, record: IJackpotHistoryItem) => value,
                sorter: (a: any, b: any) => stringCompare(a.location, b.location),
                width: 150
              },
              {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
                render: (value: string) => value,
                sorter: (a: any, b: any) => stringCompare(a.type, b.type),
                width: 100
              },
              {
                title: 'Internal IP',
                dataIndex: 'lastKnownInternalIp',
                key: 'lastKnownInternalIp',
                render: (value: string) => value || '--',
                sorter: (a: any, b: any) => stringCompare(a.lastKnownInternalIp || '--', b.lastKnownInternalIp || '--'),
                width: 150
              },
              {
                title: 'Version',
                dataIndex: 'lastKnownVersion',
                key: 'lastKnownVersion',
                render: (value: string) => value || '--',
                sorter: (a: any, b: any) => stringCompare(a.lastKnownVersion || '--', b.lastKnownVersion || '--'),
                width: 100
              },
              {
                title: 'Activation',
                dataIndex: 'lastActivation',
                key: 'lastActivation',
                render: (value: string) => value,
                sorter: (a: any, b: any) => compareDates(
                    a.lastActivation!=null?dayjs(a.lastActivation).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME): dayjs(new Date(0)).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME),
                    b.lastActivation!=null?dayjs(b.lastActivation).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME): dayjs(new Date(0)).format(DateFormatEnum.MONTH_DAY_YAEAR_TIME),
                    DateFormatEnum.MONTH_DAY_YAEAR_TIME
                ),
                width: 150
              },
              {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render: (value: string) => getStatusLabel(value),
                sorter: (a: any, b: any) => stringCompare(a.status, b.status),
                width: 100
              },
              {
                title: 'Actions',
                dataIndex: 'id',
                key: 'id',
                render: (value: string, record: any) => getActionButtons(value, record),
                width: 50
              },
            ]}
        />
      </div>
  )
}

export default Devices
